import {BaseApp} from "@/shared/BaseApp";
import {StyledBoxColumn} from "@/shared/StyledComponents";
import {Typography} from "@mui/material";
import Lottie from "lottie-react";
import {Action} from "@/shared/types";
import React from "react";
import sentAnim from "./res/anim/sent.json";

export class MessageSentHelper {

  private constructor() {
  }

  static showSentDialog(): void {
    BaseApp.CONTEXT.showCustomDialog("Success", <StyledBoxColumn
        style={{alignItems: "center"}}>
        <Typography>Message sent</Typography>
        <Lottie animationData={sentAnim} loop={false}/>
      </StyledBoxColumn>,
      new Action("OK", () => {
      }));
  }
}